import React from 'react'
import { useS4LContext } from '@s4l/react-context'
import styles from './styles.module.css'
import { Button } from '@s4l/ds'
import { IconMap } from '@s4l/icons/IconMap'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'

const MapSelector = () => {
  const { i18n } = useS4LContext()

  return (
    <div className={styles.base}>
      <Button variant="outlined-rounded" size="medium" leadingIcon={<IconMap />}>
        {i18n.formatMessage({ id: 'global.map-view' })}
      </Button>
    </div>
  )
}

MapSelector.displayName = 'MapSelector'
export default withErrorBoundary(MapSelector)
